import { z } from 'zod';
import { baseString } from './core/primitives';
import { str } from './core/helpers';

// ── Constants ───────────────────────────────────────────────────────────────
const ORG_NAME_MIN_LENGTH = 3;
const ORG_NAME_MAX_LENGTH = 100;
const ORG_NAME_PATTERN = /^[a-zA-Z0-9\s\-']+$/;

// ── Field definitions ───────────────────────────────────────────────────────

export const organizationNameField = (t) =>
  z.preprocess(
    str,
    baseString
      .min(1, t('organization_name_required'))
      .min(ORG_NAME_MIN_LENGTH, t('organization_name_min_length'))
      .max(ORG_NAME_MAX_LENGTH, t('organization_name_max_length'))
      .regex(ORG_NAME_PATTERN, t('organization_name_invalid_chars'))
  );

export const organizationTypeField = (t) =>
  z.preprocess(
    str,
    z.enum(['internal', 'external'], {
      error: t('organization_type_required'),
    })
  );

// ── Schemas ─────────────────────────────────────────────────────────────────

export const organizationFormSchema = (t) =>
  z
    .object({
      name: organizationNameField(t),
      type: organizationTypeField(t),
      category_id: z.union([z.string(), z.number()]).optional(),
    })
    .refine(
      (data) =>
        data.type !== 'external' ||
        (data.category_id != null && data.category_id !== ''),
      {
        message: t('category_required_for_external'),
        path: ['category_id'],
      }
    );

export { ORG_NAME_MIN_LENGTH, ORG_NAME_MAX_LENGTH, ORG_NAME_PATTERN };
